import FBLearnmore from "../FBLearnmore";
import stringToHash from "../../data/dataUtils";

class FBLearnmoreBuilder {
  static buildFBLearnmore(title, informationChunks, subrightID) {
    if (title == null || informationChunks == null || subrightID == null) {
      return null;
    } else if (
      typeof title !== "string" ||
      !Array.isArray(informationChunks) ||
      typeof subrightID !== "string"
    ) {
      return null;
    }

    const titleHash = stringToHash(title);
    const hashedInfoChunks = this.#hashInfoChunkTextThenPush(informationChunks);
    return new FBLearnmore(
      title,
      informationChunks,
      subrightID,
      titleHash,
      hashedInfoChunks
    );
  }

  static buildJSONToPush(fbLearnmore) {
    return {
      informationChunks: fbLearnmore.hashedInfoChunks,
      subrightID: fbLearnmore.subrightID,
      title: fbLearnmore.titleHash,
    };
  }

  static #hashInfoChunkTextThenPush(informationChunks) {
    const hashedInfoChunks = [];

    informationChunks.forEach((infoChunk) => {
      const bodyString = infoChunk.body;
      const headerString = infoChunk.header;
      const bodyHash = stringToHash(bodyString);
      const headerHash = stringToHash(headerString);
      hashedInfoChunks.push({ header: headerHash, body: bodyHash });
    });

    return hashedInfoChunks;
  }
}

export default FBLearnmoreBuilder;
